export default __webpack_public_path__ + "static/media/page6Image1.83f54c8e.png";